import { createSlice } from '@reduxjs/toolkit';
import { fetchNotes } from '../fetch/fetchNotes';
import { createReducer } from './createReducer';
var fetch = fetchNotes;   
const notes = 
createSlice({
    name: "notes",
    initialState: {
        isLoading: false,
        value: null,
        isError: false,
        tip:null,
    },
    extraReducers: (builder) => {
        builder.addCase(fetch.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(fetch.fulfilled, (state, action) => {
            state.isLoading = false;

            let data = action.payload;

            state.value = data;
        })
        builder.addCase(fetch.rejected, (state, action) => {
            state.isError = true;
        })
    },
    reducers: {

        setTip(state, action) { 
            state.tip = action.payload;
        },
    }
});

export const selectNotes = (state) => state.notes.value
export const selectLoadingNotes = (state) => state.notes.isLoading

export const selectNotesTip = (state) => state.notes.tip

export const { setTip } = notes.actions

export default notes.reducer

